import { GithubIcon, TwitterIcon, LinkedInIcon } from '../icons/SocialIcons';
import Link from 'next/link';
import { useState } from 'react';
import { EmailModal } from '../common/EmailModal';

export function Footer() {
  const [showModal, setShowModal] = useState(false);

  return (
    <footer className="bg-white dark:bg-gray-800 shadow-inner">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-6 md:space-y-0">
          {/* Social Links and Navigation */}
          <div className="flex flex-wrap justify-center gap-4 md:order-2">
            <div className="flex items-center gap-4">
              <Link href="/about" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                About
              </Link>
              <Link href="/careers" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                Careers
              </Link>
              <Link href="/news" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                News
              </Link>
              <button 
                onClick={() => setShowModal(true)}
                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
              >
                Contact
              </button>
            </div>
            <div className="flex space-x-4 md:ml-8">
              <a href="https://github.com/First-Commit-dev" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">GitHub</span>
                <GithubIcon />
              </a>
              <a href="#" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">Twitter</span>
                <TwitterIcon />
              </a>
              <a href="https://www.linkedin.com/company/first-commit-25/?viewAsMember=true" className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                <span className="sr-only">LinkedIn</span>
                <LinkedInIcon />
              </a>
            </div>
          </div>

          {/* Terms and Copyright */}
          <div className="flex flex-col items-center md:order-1">
            <div className="flex flex-wrap justify-center gap-4 mb-4">
              <Link href="/terms" className="text-sm text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                Terms of Service
              </Link>
              <Link href="/privacy-service" className="text-sm text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
                Privacy Policy
              </Link>
            </div>
            <p className="text-center text-base text-gray-400">
              &copy; 2025 FirstCommit. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      <EmailModal 
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Contact Us"
        description="Feel free to reach out to us at:"
        email="hi@first-commit.dev"
      />
    </footer>
  );
} 